// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// import toggleModal from './modules/gallery-modal';

// Swup setup
import Swup from 'swup';
const options = {
	containers: [
			'#body-wrapper',
	],
};
const swup = new Swup(options);

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).ready(() => {
	// Place one off code here - such as click events for the menu
	setup_menu_trigger();
	toggle_modal();
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Load Events when using Swup
swup.on('contentReplaced', () => {
	routes.loadEvents()
	toggle_modal()
	if($('body').hasClass('menu-active'))
	{
		//Close the menu
		$('.menu-trigger').first().click();

		//Update the active menu class
		update_active_menu_items();
	}
});

//Compares the url of the address bar to the menu items and adds appropriate classes
function update_active_menu_items()
{
    //Update the menu based on urls
    let url = window.location.href;
    let hash = window.location.hash;
    url = url.replace(hash, '');

    let menu_selectors = $('a.menu-item');
    menu_selectors.removeClass('current-menu-item');

	$('li.menu-item.current-menu-item').removeClass('current-menu-item');
    let active_items = $('nav').find('a[href="' + url + '"]');
    active_items.each(function(){
        $(this).parent().addClass('current-menu-item');
    });
}

function setup_menu_trigger()
{
	$('.menu-trigger').click(function (e){
		e.preventDefault();
		let body = $('body');
		if(body.hasClass('menu-active'))
		{
			body.removeClass('menu-active');
		}
		else
		{
			body.addClass('menu-active');
		}
	});

	$('.menu').click(function(e){
		if(e.target != this)
		{
			//Not the actual object
			return;
		}
		$('.menu-trigger').first().click();
	})

	$('.menu .inner-wrapper').click(function(e){
		if(e.target != this)
		{
			//Not the actual object
			return;
		}
		$('.menu-trigger').first().click();
	})
}

function toggle_modal()
{

	$('.toggle-modal').on('click', function () {

		if ($(this).hasClass('modal-image__close')) {
			$('.modal-image.active').removeClass('active');
		}
		else {
			let modal = $(this).parent().find('.modal-image');

			modal.hasClass('active')
				? modal.removeClass('active')
				: modal.addClass('active');
		}
	});
}




// WEBPACK FOOTER //
// ./scripts/main.js